export default ".error {\n  color: red;\n}\n\n.warning {\n  color: orange;\n}\n\n.change-applicant-modal {\n  min-width: 800px;\n}";